'use client';
import React from 'react';
import styles from './styles.module.scss';
import { PrefetchOnHoverLink } from '@/app/ui/components/prefetchonhoverlink';

type Props = {
  quicklinks:
    | {
        label: string;
        path: string;
        selected?: boolean;
      }[]
    | undefined;
  title: string;
};

const QuicklinksPDP = ({ quicklinks, title }: Props) => {
  if (!quicklinks?.length) return;

  return (
    <div className={'position-relative'} style={{ marginTop: '3rem', marginBottom: '3rem' }}>
      <p className={styles['content-title']}>{title}</p>
      <div className={styles['content-links']}>
        {quicklinks?.map((link) => {
          return (
            <PrefetchOnHoverLink key={link.label} href={link.path} className={'btn btn-grey-hover-black m-1'}>
              {link.label}
            </PrefetchOnHoverLink>
          );
        })}
      </div>
    </div>
  );
};

export default QuicklinksPDP;
